import { Role } from 'hooks/common/useRole';
import {
  ROUTE_EMPLOYERS,
  ROUTE_SETTINGS,
  ROUTE_IRA_ACCOUNTS,
  ROUTE_CONTRIBUTIONS,
  ROUTE_ETZ_PROFILE,
} from 'constants/routes';
import {
  BanckAccountIcon_24,
  ContributionsIcon_24,
  EmployerIcon_24,
  IraIcon_24,
  SettingsIcon_24,
} from 'assets/icons';
import messages from './SidebarMenu.messages';

export interface Pages {
  path: string[];
  title: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  permittedRoles: Role[];
  component?: (props?: any) => JSX.Element;
}

export const Pages: Pages[] = [
  {
    path: [ROUTE_ETZ_PROFILE],
    title: messages.etzProfile,
    icon: BanckAccountIcon_24,
    permittedRoles: [Role.Admin],
  },
  {
    path: [ROUTE_EMPLOYERS],
    title: messages.employers,
    icon: EmployerIcon_24,
    permittedRoles: [Role.Admin],
  },
  {
    path: [ROUTE_IRA_ACCOUNTS],
    title: messages.iraAccounts,
    icon: IraIcon_24,
    permittedRoles: [Role.Admin],
  },
  {
    path: [ROUTE_CONTRIBUTIONS],
    title: messages.contributions,
    icon: ContributionsIcon_24,
    permittedRoles: [Role.Admin],
  },
  {
    path: [ROUTE_SETTINGS],
    title: messages.settings,
    icon: SettingsIcon_24,
    permittedRoles: [Role.User, Role.Admin],
  },
];
